<template>
  <div>

    <el-row style="margin-bottom:10px;">
      <el-col :span="18" class='flex'>
        <el-select v-if="theUserProject==0" v-model='theProjectId' @change="theProjectAllChange" size="small" clearable placeholder="请选择项目">
            <el-option
                v-for="item in getProjectList_data.data||[]"
                :key="item.projectId"
                :label="item.projectName"
                :value="item.projectId">
            </el-option>
        </el-select>
        <el-select v-model='theUmiType' @change="theUmiTypeAllChange" size="small" clearable placeholder="请选择类型">
            <el-option
                v-for="item in theUmiTypeAll"
                :key="item.id"
                :label="item.name"
                :value="item.id">
            </el-option>
        </el-select>
        <el-input
          v-model="getUserMoreIncomeList_data.userName"
          placeholder="请输入用户名称"
          clearable
          size='small'
          style="max-width:380px;"/>
        <el-button
          v-click.getUserMoreIncomeList
          type="primary"
          icon='el-icon-search'
          size='small'
          style='margin-left:10px;'
        >搜索
        </el-button>
      </el-col>
    </el-row>

    <mytable
      :tableColums='tableColums_getUserMoreIncomeList'
      api='getUserMoreIncomeList'
      xupdateapi='updateUserMoreIncome'
      :height="H-165" >
    </mytable> 

  </div>
</template>

<script>
export default {
  data() {
    return {
      theProjectId:"",
      theUserProject:1,

      theUmiType:"",

      theUmiTypeAll:[
          {id:1,name:"首单"},
          {id:2,name:"最大单"},
          {id:3,name:"普通单"},
      ],

      tableColums_getUserMoreIncomeList: {
        $selection: false,

        umiType: ['类型',,'@v-if: 1:首单#danger, 2:最大单#danger, 3:普通单'],

        umiRemark: '描述',

        umiMoney: '金额',

        userName: '用户',

        createtime: '时间',

      },

    };
  },

  watch: {
    
  },

  methods: {
      theProjectAllChange(e){
          this.theProjectId=e;
          this.getUserMoreIncomeList({projectId:this.theProjectId,umiType:this.theUmiType});
      },
      theUmiTypeAllChange(e){
          this.theUmiType=e;
          this.getUserMoreIncomeList({projectId:this.theProjectId,umiType:this.theUmiType});
      }
  },

  created() {
    this.getProjectList({pageSize:0});
    this.theUserProject=A.local('$projectId');
    if(this.theUserProject!=0){
      this.theProjectId=this.theUserProject;
    }
    this.getUserMoreIncomeList({projectId:this.theProjectId,umiType:this.theUmiType});
  },
  mounted(){
    
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/bussiness/IncomeManage.vue